// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.right-block[data-v-9528ae8e] {\n  max-width: 40rem;\n}\n.display-flex > *[data-v-9528ae8e] {\n  width: 50%;\n}\n@media (max-width: 992px) {\n.display-flex[data-v-9528ae8e] {\n    flex-direction: column;\n}\n.display-flex > *[data-v-9528ae8e] {\n    width: 100%;\n}\n.details-item[data-v-9528ae8e] {\n    padding: 0.2rem 0.25rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
